import React, { Component } from 'react'
import { connect } from 'react-redux'
import shortid from 'shortid';
import Slider from 'react-rangeslider'
import * as d3 from "d3";

// To include the default styles
import 'react-rangeslider/lib/index.css'

import Button from '../../components/Button/Button.js'

import './Pattern.css';

var renderClient =  require('../../pattern_utilities/renderClient.js');
var SvgSaver = require('svgsaver');

var drawTimeout = {}, i;

class Pattern extends Component {

  constructor(props){
    super(props);

    // console.log('pattern', props.pattern);

    this.state = {
      id: props.id || shortid.generate(),
      rendering: true,
      paused: false,
      pattern: props.pattern,
      type: props.pattern.type,
      units: props.pattern.units,
      rows: props.pattern.rows,
      name: props.pattern.name,
      rulers: props.rulers,
      errors: props.errors,
      zoomSlider: props.zoomSlider,
      thumbnail: props.thumbnail,
      thumbnailScale: props.thumbnailScale,
      origin: props.origin || {x: -1, y: 1},
      gui: props.gui === undefined ? true : props.gui,
      colors: props.colors === undefined ? true : props.colors,
      sliderValue: 1,
      fixedScale: props.fixedScale || false
      // colors: {
      //   light: {
      //     bg: '#fff',
      //     lines: '#222',
      //     grid: '#ccc',
      //     rulerBG: '#fff',
      //     rulerEdge: '#fff',
      //     rulerTicks: '#155589'
      //   },
      //   dark: {
      //     bg: '#1d2226',
      //     lines: '#fff',
      //     grid: '#666',
      //     rulerBG: '#1d2226',
      //     rulerEdge: '#1d2226',
      //     rulerTicks: '#5BA5E6'
      //   }
      // }
    }

    this.handleSliderChange = this.handleSliderChange.bind(this);
    this.draw = this.draw.bind(this);
  }

  render(){

    return <div className="pattern-wrapper" id={'pw-' + this.state.id} key={'pw-' + this.state.id}>

      {!this.props.thumbnail && this.state.zoomSlider &&
        <div className="pattern-slider-wrapper">
          <Slider
            min={.2}
            max={10}
            step={0.2}
            orientation={'vertical'}
            value={this.state.sliderValue}
            tooltip={false}
            onChange={this.handleSliderChange}
          />
        </div>
      }
      
      <canvas id={'pat-' + this.state.id} className="pattern"></canvas>

      {
        this.state.rendering && <div className="pattern-rendering-overlay">
          <i className="far fa-spinner-third fa-spin fa-2x text-secondary"/>
        </div>
      }

      {
        this.state.paused && <div className="pattern-rendering-overlay">
          <div className="flex-center-column">
            <p className="text-center"><small>Due to the large number of rows in this .PAT file,<br/>automatic rendering is currently paused.</small></p>
            <Button
              display="Render Now"
              color="primary"
              onClick={()=>{
                this.draw(true);
              }}
              />
          </div>
        </div>
      }
    </div>
  }

  handleSliderChange(value){
    if(value === this.state.sliderValue) return;
    this.setState({
      sliderValue: value
    });
    clearTimeout(drawTimeout[this.state.id]);
    drawTimeout[this.state.id] = setTimeout(()=>{ this.draw(true); }, 200);
  }


  componentWillReceiveProps(newprops, oldprops){
    // console.log('pattern new props', newprops, this.state);

    var wrapper = document.getElementById('pw-' + this.state.id);
    var width = wrapper.offsetWidth;
    var height = wrapper.offsetHeight;

    var origin = newprops.origin;
    if(!origin){
      origin = this.state.origin;
    }

    // console.log(newprops.pattern.hashedRowsAndStyle, this.state.hashedRowsAndStyle, newprops.pattern.jdiSettings.canvas_width,newprops.pattern.jdiSettings.canvas_height);
    
    if(newprops.light !== this.state.lights 
    || newprops.pattern.id !== this.state.cacheID 
    || width !== this.state.width 
    || height !== this.state.height 
    || newprops.pattern.hashedRowsAndStyle !== this.state.hashedRowsAndStyle 
    || newprops.rulers !== this.state.rulers
    || newprops.errors !== this.state.errors 
    || origin.x !== this.state.origin.x 
    || origin.y !== this.state.origin.y 
    || newprops.zoomSlider !== this.state.zoomSlider 
    || newprops.gui !== this.state.gui 
    || newprops.colors !== this.state.colors 
    || newprops.pattern.units !== this.state.units 
    || newprops.pattern.decimal_places !== this.state.decimal_places 
    || newprops.pattern.fixedScale !== this.state.fixedScale
    || newprops.pattern.type !== this.state.type){

      this.setState({
        cacheID: newprops.pattern.id,
        type: newprops.pattern.type,
        units: newprops.pattern.units,
        rows: newprops.pattern.rows,
        decimal_places: newprops.pattern.decimal_places,
        hashedRowsAndStyle: newprops.pattern.hashedRowsAndStyle,
        name: newprops.pattern.name,
        rulers: newprops.rulers,
        errors: newprops.errors,
        zoomSlider: newprops.zoomSlider,
        origin: newprops.origin || {x: -1, y: 1},
        gui: newprops.gui,
        colors: newprops.colors,
        width: width,
        height: height,
        pattern: newprops.pattern,
        lights: newprops.light,
        fixedScale: newprops.fixedScale
      });
      clearTimeout(drawTimeout[this.state.id]);
      drawTimeout[this.state.id] = setTimeout(this.draw, 200);
    }
  }

  componentDidMount(){
    this.draw();
    window.addEventListener('resize', () =>{
      clearTimeout(drawTimeout[this.state.id]);
      drawTimeout[this.state.id] = setTimeout(this.draw, 200);
    });
  }

  draw(force){
    const { globalReducer, user, team } = this.props;

    if(!force && this.state.pattern.rows.length > 1000){
      if(!this.state.paused){
        this.setState({
          paused: true
        })
      }
      return;
    }

    if(this.state.paused){
      this.setState({
        paused: false
      })
    }


    var c = document.getElementById("pat-" + this.state.id);
    if(!c) return;

    var w = c.scrollWidth || c.width;
    var h = c.scrollHeight || c.height;

    if(w === 0 || h === 0) return;

    this.setState({
      rendering: true
    })

    // console.log("SEND NEW RENDER REQUEST");

    renderClient('pat-' + this.state.id, this.state.pattern, {
      width: w,
      height: h,
      lights:  (globalReducer.lights || (!user.roles.pro && !team.current)) || this.props.light,
      scaleValue: this.state.sliderValue,
      gui: this.state.gui,
      colorLines: this.state.colors,
      zoomSlider: this.state.zoomSlider,
      rulers: this.props.rulers,
      showErrors: this.props.errors,
      origin: this.state.origin,
      thumbnail: this.props.thumbnail,
      fixedScale: this.props.fixedScale
    }, (e) => {
      // render has finished;

      this.setState({
        rendering: false
      })
    });
  }
}


const mapStateToProps = (state) => {
  const { 
    globalReducer, user, team
  } = state;

  return {
    globalReducer, user, team
  }
}


export default connect(mapStateToProps)(Pattern);


// WEBPACK FOOTER //
// ./src/components/Pattern/Pattern.js